export const US_CITIZEN = 'US_CITIZEN';
export const RESIDENT_ALIEN = 'RESIDENT_ALIEN';
export const SSN_LABEL = 'SSN';
export const SSN_LABEL_FOR_ALIEN = 'SSN/Tax ID';

export const mapCitizenshipToSsnLabel = citizenship =>
  ({ US_CITIZEN: SSN_LABEL, RESIDENT_ALIEN: SSN_LABEL_FOR_ALIEN }[
    citizenship
  ] || SSN_LABEL);

export const maskSsnForDisplay = ssn => ssn && ssn.replace(/^.{5}/g, '*****');

export const invalidCitizenshipValue = val => {
  if ({ US_CITIZEN, RESIDENT_ALIEN }[val]) return false;
  return true;
};
